import styles from './SubNavBar.scss';

import cx from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { useScrollPosition } from 'src/hooks/UseScrollPosition';
import { useCMS } from 'src/hooks/useCMS';
import { getFlattenedSubNavigation } from 'src/services/cms/navigation/flattenNavigation';

export const SubNavBar: FC = () => {
  const subNavigation = useCMS(getFlattenedSubNavigation);
  const [showNavBar, setShowNavBar] = useState(false);
  const { scrollPos } = useScrollPosition();

  useEffect(() => {
    setShowNavBar((scrollPos >= 60));
  }, [scrollPos]);

  if (!subNavigation) return null;

  return (
    <header className={cx(styles.subNavBar, showNavBar && styles.subNavBarShow)} />
  );
};
